import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { Container } from 'components/cms/Container';
import { ComponentProps } from 'lib/component-props';

export type ContainerRenderingProps = ComponentProps & {
	rendering: {
		params: {
			Variant: string;
		};
	};
};

const ContainerRendering = (props: ContainerRenderingProps): JSX.Element => {
	return (
		<>
			<Container rendering={props.rendering}>
				{<Placeholder name='bbi-cms-container' rendering={props.rendering} />}
			</Container>
		</>
	);
};

export default ContainerRendering;
